import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=74d077ac&scoped=true&"
import script from "./DiscountItem.vue?vue&type=script&lang=ts&"
export * from "./DiscountItem.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountItem.vue?vue&type=style&index=0&id=74d077ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d077ac",
  null
  
)

export default component.exports